import {
  useToast,
  type ToastMessageOptions,
  type ToastServiceMethods,
} from 'primevue';

export const useStwToast = (): ToastServiceMethods => {
  const toast = useToast();

  const add = (options: ToastMessageOptions) => {
    toast.add({
      life: 5000,
      ...options,
    });
  };

  return {
    ...toast,
    add,
  };
};
